import $axios from "axios";

const axios = $axios.create({baseURL: 'https://admin.unisphere.world'})

export default axios;